import { useEffect } from 'react';
import { vevet } from '@anton.bobrov/vevet-init';
/** Event on viewport resize */
export function useOnResize(effect, deps, settings) {
    useEffect(function () {
        var _a;
        var destructor = effect();
        var target = (_a = settings === null || settings === void 0 ? void 0 : settings.target) !== null && _a !== void 0 ? _a : 'any';
        target =
            (settings === null || settings === void 0 ? void 0 : settings.isMobileOptimizedTarget) && vevet.isMobile ? 'width' : target;
        var viewportCallback = vevet.viewport.add(target, function () {
            destructor === null || destructor === void 0 ? void 0 : destructor();
            destructor = effect();
        }, settings);
        return function () {
            viewportCallback.remove();
            destructor === null || destructor === void 0 ? void 0 : destructor();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
//# sourceMappingURL=useOnResize.js.map